import React from 'react'
import {PageName} from './style'

export const Header = () => <PageName>Todo</PageName>